import i18n from '@shared/i18n/index';
import { faqMarkdownToHtml } from './markdownToHtml';
import styles from './index.module.less';
import matrixAssets from '@shared/matrix';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { product } from '@shared/matrix/const';

interface FAQContentProps {
	inPopup?: boolean;
}

export function FAQContent({ inPopup }: FAQContentProps = {}) {
	const content = i18n.get('FAQ_Content_V3', {
		product,
		email: matrixAssets.text.Matrix_Contact_Email,
	});

	const logo = (
		<NewBaseIcon
			icon={matrixAssets.svg.Matrix_Logo}
			style={{ width: 'auto', height: 'auto' }}
			aria-label={product}
		/>
	);

	return (
		<div className={styles.faqWrapper}>
			<div className={styles.faqContainer}>
				{inPopup ? (
					<div className={styles.logo}>{logo}</div>
				) : (
					<a className={styles.logo} href="/">
						{logo}
					</a>
				)}
				<div className={styles.faqTitle}>{i18n.get('FAQ_Title')}</div>
				<div
					className={styles.faqContent}
					dangerouslySetInnerHTML={{ __html: faqMarkdownToHtml(content) }}
				/>
			</div>
		</div>
	);
}
